module.exports = __webpack_public_path__ + "img/5584a35.png";